import {
  ProductState,
  ProductActionTypes,
  LOAD_PRODUCTS_STARTED,
  LOAD_PRODUCTS_SUCCESS,
  LOAD_PRODUCTS_FAILURE,
  LoadProductsSucces,
} from './types';
import { cloneDeep } from 'lodash';

const initialState: ProductState = {
  isFetching: false,
  didInvalidate: false,
  products: [],
};

const loadProductsStarted = (state: ProductState) => {
  const newState = cloneDeep(state);

  newState.isFetching = true;
  newState.didInvalidate = false;

  return {
    ...state,
    ...newState,
  };
};

const loadProductsSuccess = (
  state: ProductState,
  action: LoadProductsSucces,
) => {
  const newState = cloneDeep(state);

  newState.isFetching = false;
  newState.didInvalidate = false;
  newState.products = action.payload.products.sort(
    // sort by price descending, then by name ascending
    (a, b) => b.price - a.price !== 0 ? b.price - a.price : a.name < b.name ? -1 : +(a.name > b.name)
  );

  return {
    ...state,
    ...newState,
  };
};

const loadProductsFailure = (state: ProductState) => {
  const newState = cloneDeep(state);

  newState.isFetching = false;
  newState.didInvalidate = true;

  return {
    ...state,
    ...newState,
  };
};

export const productReducer = (
  state = initialState,
  action: ProductActionTypes,
): ProductState => {
  switch (action.type) {
    case LOAD_PRODUCTS_STARTED:
      return loadProductsStarted(state);
    case LOAD_PRODUCTS_SUCCESS:
      return loadProductsSuccess(state, action);
    case LOAD_PRODUCTS_FAILURE:
      return loadProductsFailure(state);
    default:
      return state;
  }
};
